import { COLORS_THEME_DEFAULT, COLORS_THEME_MODERN } from '../../../Themes/Themes'
import theme_modern from './theme_modern'
import theme_default from './theme_default'

export const Themes = {
    [COLORS_THEME_DEFAULT]: theme_default,
    [COLORS_THEME_MODERN]: theme_modern,
}
